import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from "rxjs/Observable";
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { ProviderService } from "../provider-management/provider-management.service";

import { ReferenceTableService } from '../reference-table.service';
import {
  Announcement,
  DataService,
  CommonUtility,
  DateUtility,
  ServerConstantsService,
} from "../shared";
import { CanComponentDeactivate, CanDeactivateGuard, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-admin-announcement-details',
  templateUrl: './admin-announcement-details.component.html',
  styleUrls: ['./admin-announcement-details.component.scss'],
})
export class AdminAnnouncementDetailsComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('prevText') prevText: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('prevTab') prevTab: ElementRef;
  @ViewChild('desc') desc: ElementRef;
  @ViewChild('desc1') desc1: ElementRef;
  @ViewChild('provider') provider: ElementRef;
  @ViewChild('disabledCounty') disabledCounty: ElementRef;
  assignedToInd: any;
  today: Date = new Date();
  minESDate: NgbDateStruct;
  minRDDate: NgbDateStruct;
  maxRDDate: NgbDateStruct;
  serverConstants: any;
  sharedData: any;
  refData: any;
  priorityArray: any[];
  priorityMap: any;
  priorityJson: any;
  audiencesArray: any[];
  audiencesMap: any;
  audiencesJson: any;
  countyArray: any[];
  countiesMap: any;
  countiesJson: any;
  minValidateFromDt: any;
  minValidateToDt: any;
  adminAnnouncement: Announcement;
  adminAnnouncementOld: Announcement;
  disabledTab: any = "-1";
  isPeoviderDisable = true;
  isCountyDisable = true;
  isResetDisable: boolean = true;
  isChangeDetected: boolean;
  userActionNotificationsMap: any;
  providerArray: any[];
  selectAll = false;
  notesSize = 0;
  showWeekdays = false;
  isProviderDisableTab: any = "-1";
  isCountyDisableTab: any = "-1";
  isFocused = false;
  dropdownSettings: any = {};
  selectedAll = false;
  countiesModel = [];
  providersModel = [];
  requiredDropdown = true;

  constructor(
    private serverConstantsService: ServerConstantsService,
    public dataService: DataService,
    private data: ReferenceTableService,
    private dateUtility: DateUtility,
    private commonUtil: CommonUtility,
    private http: HttpClient,
    private router: Router,
    private notificationService: NotificationsService,
    private providerService: ProviderService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = this.serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get("ADCMT") == undefined) {
      this.router.navigate(['/admin/announcementsSummary']);
    }
    this.adminAnnouncement = new Announcement();
  }

  ngOnInit() {
    /* Load Reference Tables*/
    this.http.get<any>(this.serverConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role : ' + data.roles[0].id);
            if(data.roles[0].id === 5){
                this.router.navigate(['dashboard']);
              }
            }}
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
    // let token = this.dataService.getSharedDataObject().get("token");
    this.providerService.findAllActiveProviders().subscribe((data) => {
      let entities: Array<any> = [];
      for (let i = 0; i < data.length; i++) {
        let providerData = {
          value: data[i].id.toString(),
          name: data[i].providerName
        };
        entities.push(providerData);
        entities.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        })
      }
      this.providerArray = entities;
      this.sharedData = this.dataService.getSharedDataObject();
      if (this.sharedData.get('adminAnnouncement') != null && this.sharedData.get('adminAnnouncement') != undefined) {
        this.adminAnnouncement = this.sharedData.get('adminAnnouncement');
        this.notesSize = this.adminAnnouncement.description.length;
        this.adminAnnouncement.effectiveFromDt = this.dateUtility.convertDateFromServer(this.adminAnnouncement.effectiveFromDt);
        this.adminAnnouncement.effectiveToDt = this.dateUtility.convertDateFromServer(this.adminAnnouncement.effectiveToDt);
        this.setAvailable();
        this.notesSize = this.adminAnnouncement.description.length;
        if (this.adminAnnouncement.counties !== undefined && this.adminAnnouncement.counties !== null) {
          this.countiesModel = this.adminAnnouncement.counties;
          for (let i = 0; i < this.adminAnnouncement.counties.length; i++) {
            for (let j = 0; j < this.countyArray.length; j++) {
              if (this.adminAnnouncement.counties[i] == this.countyArray[j].value) {
                this.adminAnnouncement.counties[i] = this.countyArray[j];
                this.countiesModel[i] = this.countyArray[j];
              }
            }
          }
        }
        if (this.adminAnnouncement.providers !== undefined && this.adminAnnouncement.providers !== null && this.providerArray !== undefined) {
          this.providersModel = this.adminAnnouncement.providers;
          for (let i = 0; i < this.adminAnnouncement.providers.length; i++) {
            for (let j = 0; j < this.providerArray.length; j++) {
              if (this.adminAnnouncement.providers[i] == this.providerArray[j].value) {
                this.adminAnnouncement.providers[i] = this.providerArray[j];
                this.providersModel[i] = this.adminAnnouncement.providers[i];
              }
            }
          }
        }
      }
      else {
        this.adminAnnouncement = new Announcement();
        this.adminAnnouncement.priorityCd = null;
      }
    });
    this.dataService.globalAccess = true;


    this.maxRDDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };

    this.minESDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    // this.maxRDDate = {
    //   month: this.today.getMonth() + 1,
    //   day: this.today.getDate(),
    //   year: this.today.getFullYear()
    // };
    // this.minESDate = {
    //   month: this.adminAnnouncement.effectiveFromDt["month"],
    //   day: this.adminAnnouncement.effectiveFromDt["day"],
    //   year: this.adminAnnouncement.effectiveFromDt["year"]
    // }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
  
}, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});
  }

  onQuickTextChanged($event) {
    this.notesSize = this.adminAnnouncement.description.length;
  }

  getFromDate() {
    this.minESDate = {
      month: this.adminAnnouncement.effectiveFromDt["month"],
      day: this.adminAnnouncement.effectiveFromDt["day"],
      year: this.adminAnnouncement.effectiveFromDt["year"]
    }
  }

  // validate() {
  //   if (this.adminAnnouncement.effectiveFromDt != undefined) {
  //     this.minValidateToDt = {
  //       day: this.adminAnnouncement.effectiveFromDt.day,
  //       month: this.adminAnnouncement.effectiveFromDt.month,
  //       year: this.adminAnnouncement.effectiveFromDt.year
  //     }
  //   } 
  // }

  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }

  setAvailable() {
    switch (this.adminAnnouncement.audienceCd) {
      case "CP":
        this.isPeoviderDisable = true;
        this.isCountyDisable = true;
        this.selectAll = true;
        this.adminAnnouncement.counties = undefined;
        this.countiesModel = [];
        this.adminAnnouncement.providers = undefined; 
        this.providersModel = [];
        break;
      case "PS":
        this.isPeoviderDisable = false;
        this.isCountyDisable = true;
        this.selectAll = false;
        this.adminAnnouncement.counties = undefined;
        this.countiesModel = [];
        break;
      case "SS":
        this.isCountyDisable = false;
        this.isPeoviderDisable = true;
        this.selectAll = false;
        this.adminAnnouncement.providers = undefined;
        this.providersModel = [];
        break;
      case "BO":
        this.isCountyDisable = false;
        this.isPeoviderDisable = false;
        this.selectAll = false;
        break;
      case "AL":
        this.isPeoviderDisable = true;
        this.isCountyDisable = true;
        this.selectAll = true;
        this.adminAnnouncement.counties = undefined;
        this.countiesModel = [];
        this.adminAnnouncement.providers = undefined; 
        this.providersModel = [];
        break; 
    }
  }

  parseRefTableData(myData) {
    if (myData != undefined && myData.englishDropDown) {
      this.priorityArray = myData.englishDropDown["PRIORITY"];
      this.priorityMap = this.commonUtil.createMapFromList(this.priorityArray);
      this.priorityJson = this.commonUtil.createNativeMapFromList(this.priorityArray);
      this.countyArray = myData.englishDropDown["COUNTIES"];
      this.countiesMap = this.commonUtil.createMapFromList(this.countyArray);
      this.countiesJson = this.commonUtil.createNativeMapFromList(this.countyArray);
      this.audiencesArray = myData.englishDropDown["AUDIENCES"];
      this.audiencesMap = this.commonUtil.createMapFromList(this.audiencesArray);
      this.audiencesJson = this.commonUtil.createNativeMapFromList(this.audiencesArray);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  dataChanges() {
    this.isResetDisable = false;
    this.isChangeDetected = true;
  }



  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }

  };

  validate() {
    // const fromDate = this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveFromDt);
    // const toDate = this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveToDt);
    const date1 = new Date(this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveFromDt));
    const date2 = new Date(this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveToDt))
    const calculatedValue = this.dateUtility.compareDate(date1, date2);
    if (calculatedValue === 1) {
    }
  }

  focusFirstEnabledField() {
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
  }
  getfocusDescriptionMethod() {
    if (!this.isPeoviderDisable) {
      this.focusDescription();
    }
    if (!this.isCountyDisable) {
      this.focusDescription1();
    }
  }

  focusProviders() {
    if (this.adminAnnouncement.audienceCd == 'BO') {
      setTimeout(() => this.provider.nativeElement.focus(), 0);
    }
  }

  focusDescription() {
    setTimeout(() => this.desc.nativeElement.focus(), 0);
  }

  focusDescription1() {
    setTimeout(() => this.desc.nativeElement.focus(), 0);
  }

  focusDisabled() {
    if (this.adminAnnouncement.audienceCd == 'AL' && this.isPeoviderDisable) {
      setTimeout(() => this.desc1.nativeElement.focus(), 0);
    }
  }

  onItemDeselectCounty(deselectStatus) {
    this.countiesModel.forEach((status, index) => {
      if (status === deselectStatus) this.countiesModel.splice(index, 1);
    });
    this.adminAnnouncement.counties = this.countiesModel
    event.stopPropagation();
    this.isChangeDetected = true;
  }

  onItemDeselectProvider(deselectStatus) {
    this.providersModel.forEach((status, index) => {
      if (status === deselectStatus) this.providersModel.splice(index, 1);
    });
    this.adminAnnouncement.providers = this.providersModel;
    event.stopPropagation();
    this.isChangeDetected = true;
  }
  

  onItemSelect(item: any) {
    this.isFocused = false;
    this.selectedAll = false;
    this.isChangeDetected = true;
    this.requiredDropdown = false
  }

  onSelectAll(items: any) {
    for (let item of items) {
      this.onItemSelect(item);
    }
    this.isFocused = false;
    this.selectedAll = true;
    this.isChangeDetected = true;
    this.requiredDropdown = false;
  }

  isBothDropdownsValueValid() {
    if ((this.adminAnnouncement.providers === undefined || 
      this.adminAnnouncement.providers === null || 
      this.adminAnnouncement.providers === '' || 
      this.providersModel.length === 0 ||
      this.countiesModel.length === 0 ||
      this.adminAnnouncement.counties === undefined || 
      this.adminAnnouncement.counties === null || 
      this.adminAnnouncement.counties === '') && this.adminAnnouncement.audienceCd === 'BO') {
        return true;
      } else {
        return false;
      }
  }


  save() {
    this.adminAnnouncement.effectiveFromDt = this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveFromDt);
    this.adminAnnouncement.effectiveToDt = this.dateUtility.convertDateForServer(this.adminAnnouncement.effectiveToDt);
    if (this.adminAnnouncement.audienceCd === 'AL') {
      this.adminAnnouncement.providers = "ALL";
      this.adminAnnouncement.counties = 'ALL'
    } else {
      if (this.adminAnnouncement.audienceCd === 'PS') {
        if (this.providersModel.length > 0) {
          let list = [];
          for (let i = 0; i < this.providersModel.length; i++) {
          list.push(this.providersModel[i].value);
        }
        this.adminAnnouncement.providers = list.toString();
        } else {
          this.notificationService.error('Please select Providers form the drop-down.');
          return;
        }
      }
      if (this.adminAnnouncement.audienceCd === 'SS') {
        if (this.countiesModel.length > 0) {
          let list = [];
          for (let i = 0; i < this.countiesModel.length; i++) {
            list.push(this.countiesModel[i].value);
          }
        this.adminAnnouncement.counties = list.toString();
        } else {
          this.notificationService.error('Please select Counties form the drop-down.');
          return;
        }
      }
      if (this.adminAnnouncement.audienceCd === 'BO') {
        if (this.countiesModel.length > 0) {
          let list = [];
          for (let i = 0; i < this.countiesModel.length; i++) {
            list.push(this.countiesModel[i].value);
          }
        this.adminAnnouncement.counties = list.toString();
        } else {
          this.notificationService.error('Please select Counties form the drop-down.');
          return;
        }
        if (this.providersModel.length > 0) {
          let list = [];
          for (let i = 0; i < this.providersModel.length; i++) {
          list.push(this.providersModel[i].value);
        }
        this.adminAnnouncement.providers = list.toString();
        } else {
          this.notificationService.error('Please select Providers form the drop-down.');
          return;
        }
      }
    }
    if ((this.adminAnnouncement.providers === undefined || this.adminAnnouncement.providers === null || this.adminAnnouncement.providers === '' || this.adminAnnouncement.providers.length === 0)
    && this.adminAnnouncement.audienceCd === 'PS') {
      this.notificationService.error('Please select Provider form the drop-down.');
    } else if ((this.adminAnnouncement.counties === undefined || this.adminAnnouncement.counties === null || this.adminAnnouncement.counties === '' || this.adminAnnouncement.counties.length === 0)
    && this.adminAnnouncement.audienceCd === 'SS') {
      this.notificationService.error('Please select Counties form the drop-down.');
    } else if (this.isBothDropdownsValueValid()) {
        this.notificationService.error('Please select all required fields.');
    } else {
      this.http.post<Announcement>(this.serverConstants.SERVER_API_URL + '/announcements/provider/save', this.adminAnnouncement)
      .subscribe(
        (res: Announcement) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
          } else {
            this.isChangeDetected = false;
            this.adminAnnouncement = res;
            this.router.navigate(['/admin/announcementsSummary']);
            this.notificationService.success('Announcement', this.userActionNotificationsMap.UPDATE);
          }
        },
        (response) => {
          this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
        },
      () => {
    });
    }
  }

  reset() {
    this.isResetDisable = true;
    this.providersModel = [];
    this.countiesModel = [];
    if (this.adminAnnouncement.id !== null &&
      this.adminAnnouncement.id !== undefined) {
      this.adminAnnouncement.title = "";
      // this.announcement.effectiveFromDt
      this.adminAnnouncement.priorityCd = "";
      this.adminAnnouncement.counties = "";
      this.adminAnnouncement.description = "";
      this.isCountyDisable = true;
      this.isPeoviderDisable = true;
    } else {
      this.adminAnnouncement = new Announcement();
      this.isCountyDisable = true;
      this.isPeoviderDisable = true;
    }
  }


  focusHeader(event) {
    if (event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
    }
    if (event.shiftKey && event.keyCode == 9) {
      if (!this.isResetDisable) {
        event.preventDefault();
        setTimeout(() => this.prevText.nativeElement.focus(), 0);
      } else {
        event.preventDefault();
        setTimeout(() => this.prevTab.nativeElement.focus(), 0);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-announcement-details/admin-announcement-details.component.ts